import React from "react";
import ReactDOM from "react-dom";
import Tabs from "../Tab/Tabs";
import { RegisterPage } from "../Home/RegisterPage";
import { LoginForm } from "../Home/LoginForm";
import { configureStore } from "@reduxjs/toolkit";
import { render } from "@testing-library/react";

const Modal = ({ isShowing, hide, activeTab }) =>
  isShowing
    ? ReactDOM.createPortal(
        <React.Fragment>
          <div className="custom-modal-overlay" />
          <div
            className="custom-modal-wrapper"
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
          >
            <div className="custom-modal">
              <div className="custom-modal-header">
                <button
                  type="button"
                  className="modal-close-button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={hide}
                  style={{
                    width: "fit-content",
                    padding: 0,
                    marginTop: "5px",
                    marginRight: "5px",
                  }}
                >
                  {/* <span
                    style={{
                      fontSize: "32px",
                      fontWeight: "bold",
                      color: "black",
                      backgroundColor: "transparent",
                      padding: 0,
                    }}
                    aria-hidden="true"
                  >
                    &times;
                  </span> */}
                  {/* close */}
                  <svg
                    width="20"
                    height="20"
                    viewPort="0 0 12 12"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ backgroundColor: "transparent" }}
                  >
                    <line
                      x1="1"
                      y1="19"
                      x2="19"
                      y2="1"
                      stroke="black"
                      stroke-width="2"
                    />
                    <line
                      x1="1"
                      y1="1"
                      x2="19"
                      y2="19"
                      stroke="black"
                      stroke-width="2"
                    />
                  </svg>
                </button>
              </div>
              <div className="custom-model-content">
                {/* <h1>Tabs Demo</h1> */}
                <Tabs showIndex={activeTab}>
                  <div label="Login" style={{ fontWeight: "bold" }}>
                    <LoginForm />
                  </div>
                  <div label="SignUp" style={{ fontWeight: "bold" }}>
                    <RegisterPage cus_style={{ width: "100%" }} />
                  </div>
                </Tabs>
              </div>
            </div>
          </div>
        </React.Fragment>,
        document.body
      )
    : null;

export default Modal;
